import React from 'react';
import Tab from '@material-ui/core/Tab';
import renderIf from '@signal/utils/renderIf';
import Link from '../Link';
import Typography from '../Typography';
import { LabelWrapper, SubLabel } from './styles';
export default function NavLink(props) {
  var to = props.to,
      label = props.label,
      active = props.active,
      onClick = props.onClick,
      sublabel = props.sublabel;
  var labelComponent = /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: active ? 'textDark' : 'textSecondary'
  }, label);
  var labelDisplay = sublabel ? /*#__PURE__*/React.createElement(LabelWrapper, null, labelComponent, /*#__PURE__*/React.createElement(SubLabel, {
    color: active ? 'textDark' : 'textSecondary'
  }, sublabel)) : labelComponent;

  var handleClick = function handleClick(to) {
    return function () {
      return onClick(to);
    };
  };

  return renderIf(onClick, function () {
    return /*#__PURE__*/React.createElement(Tab, {
      label: labelDisplay,
      to: to,
      onClick: handleClick(to)
    });
  }, function () {
    return /*#__PURE__*/React.createElement(Tab, {
      label: labelDisplay,
      to: to,
      component: Link
    });
  });
}